import { Icon, IconName } from '@hills-design-system/components';
import { CmsFeature } from '../../types/contentstack';

const LINK_STYLE = { color: 'rgba(0, 84, 164, 1)' };
const LINK_CLASS = 'font-semibold flex items-center gap-[5px]';
const DATA_ICON_MAP: Record<string, IconName> = {
  'shopping-cart': IconName.ShoppingCart,
  email: IconName.Mail,
  tel: IconName.Smartphone,
};

function ContactInfoColumn({ body }: { body: string }) {
  const paragraphs = body.match(/<p>[\s\S]*?<\/p>/g) ?? [];

  return (
    <div className="flex flex-col gap-[5px] min-w-0">
      {paragraphs.map((p, i) => {
        const allHrefs = [...p.matchAll(/href="([^"]+)"/g)].map((m) => m[1]);
        const href = allHrefs[0];
        const text = p.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
        const hasTargetBlank = /target="_blank"/.test(p);
        const dataIcon = p.match(/data-icon="([^"]+)"/)?.[1];
        const hasMultipleLinks = allHrefs.length > 1;

        if (hasMultipleLinks) {
          return (
            <div
              key={i}
              className="text-detail-90 font-medium text-black/60 whitespace-pre-line [&_a]:text-[rgba(0,84,164,1)] [&_a]:underline"
              dangerouslySetInnerHTML={{ __html: p.replace(/<\/?p>/g, '') }}
            />
          );
        }
        if (dataIcon && DATA_ICON_MAP[dataIcon]) {
          return (
            <a
              key={i}
              href={href}
              className={LINK_CLASS}
              style={LINK_STYLE}
              target={hasTargetBlank ? '_blank' : undefined}
              rel={hasTargetBlank ? 'noopener noreferrer' : undefined}
            >
              <Icon icon={DATA_ICON_MAP[dataIcon]} size={18} />
              {text}
            </a>
          );
        }
        if (href) {
          return (
            <a
              key={i}
              href={href}
              className={LINK_CLASS}
              style={LINK_STYLE}
              target={hasTargetBlank ? '_blank' : undefined}
              rel={hasTargetBlank ? 'noopener noreferrer' : undefined}
            >
              <Icon icon={IconName.Mail} size={18} />
              {text}
            </a>
          );
        }
        return (
          <p key={i} className="text-detail-90 font-medium text-black/60">
            {text}
          </p>
        );
      })}
    </div>
  );
}

interface ContactFeatureCardsProps {
  features: CmsFeature[];
}

export function ContactFeatureCards({ features }: ContactFeatureCardsProps) {
  if (!features.length) return null;

  return (
    <div className="flex flex-col gap-2">
      {features.map((feature) => (
        <div
          key={feature._metadata?.uid}
          className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-[40px] bg-white rounded-lg border border-black/20 p-6"
        >
          <div
            className="contact-us-card flex flex-col gap-2 min-w-0"
            dangerouslySetInnerHTML={{ __html: feature.body.split('<p>')[0] }}
          />
          <ContactInfoColumn body={feature.body} />
        </div>
      ))}
    </div>
  );
}
